import { useState } from 'react';
import { Button } from '@mui/material';
import * as Yup from 'yup';
import { SaveHookFormDialog } from '../../../components/save-hook-form.dialog';
import { projectsApiKeyStore } from '../../../api/projects-api-key-store';
import { BuildingFloorUnitForm } from './building-floor-unit.form';
import { useFormContext } from 'react-hook-form';
import { BuildingFloorUnitFormWithDefaultValue } from './create-building-floor-with-default-unit-name';
import { ScatteredUnitFormWithDefaultValue } from './scattered-unit-form-with-default-value';
import { GuardedComponent } from '../../../components/guarded-component';
import { UserPermissionName } from '../../../models/user-permission-name';

interface CreateBuildingFloorButtonProps {
  projectID: number;
  buildingID?: number;
  floor: any;
  syncWithDux: any
  onUnitCreated: (data: any) => void;
}
const validationSchema = Yup.object().shape({
  unitData: Yup.object().shape({
    unitName: Yup.string().required('Lot/Unit is required').max(9, 'Lot/Unit cannot exceed 9 characters'),
    // jobNumber: Yup.string().required('Job number is required'),
    jobsite: Yup.string().required('Jobsite is required'),
    address: Yup.string().required('Address is required').max(31, 'Address cannot exceed 31 characters'),
  }),
});

export const CreateScatteredUnitButton = ({
  projectID,
  buildingID,
  floor,
  syncWithDux,
  onUnitCreated,
}: CreateBuildingFloorButtonProps) => {
  const [newBuilding, setNewBuilding] = useState<any>();
  const { setValue } = useFormContext();

  const handleDialogClose = () => {
    setNewBuilding(undefined);
  };

  const handleAddBuildingFloor = () => {
    setNewBuilding({
      projectID,
      floorName: '',
      unitData: {
        unitName: '',
        jobsite: '',
        jobNumber: '',
        // createWO: false,
        // syncWithDUX: false,
        buildingPermit: ''
      }
    });
  };

  const formatSubmitData = (data: any) => {
    const { floorID } = floor;
    const newData = {
      floorID: 0,
      buildingID: 0,
      unitName: data?.unitData?.unitName,
      jobNumber: data?.unitData?.jobNumber,
      jobsite: data?.unitData?.jobsite,
      address: data?.unitData?.address,
      city: data?.unitData?.city,
      stateID: data?.unitData?.state?.stateID,
      zipcode: data?.unitData?.zipcode,
      squareFeet: !data?.unitData?.squareFeet ? null : Number(data?.unitData?.squareFeet),
      countyID: data?.unitData?.county,
      municipalityID: data?.unitData?.projectMunicipalities?.municipalityID,
      proctorResult: !data?.unitData?.proctorResult
        ? null
        : {
          proctorResultsID: data?.unitData?.proctorResult.proctorResultsID,
          unitID: 0,
          proctorFileName: data?.unitData?.proctorResult.proctorFileName,
        },
      // createWO: data?.unitData?.createWO,
      // syncWithDUX: data?.unitData?.syncWithDUX,
      buildingPermit: data?.unitData?.buildingPermit
      // proctorResult: data?.unitData?.proctorResult?.map((result: any) => ({
      //   proctorResultsID: result?.proctorResultsID,
      //   unitID: 0,
      //   proctorFileName: result?.proctorFileName,
      // })),
    };

    return { projectID, ...newData };
  };

  return (
    <>
      <GuardedComponent requiredPermissions={[UserPermissionName.ADD_UNIT]}>
        <Button
          className="btn btn-primary"
          variant="text"
          sx={{ p: 0, m: 0, mr: 1, ml: 3, mb: 2 }}
          onClick={handleAddBuildingFloor}
        >
          Add Lot/Unit
        </Button>
      </GuardedComponent>
      {newBuilding && (
        <SaveHookFormDialog
          title="CREATE LOT/UNIT"
          config={{
            saveConfig: projectsApiKeyStore.createLot(),
          }}
          data={newBuilding}
          onClose={handleDialogClose}
          onSaveCompleted={onUnitCreated}
          formatSubmitdata={formatSubmitData}
          size="xl"
          yupSchema={validationSchema}
        >
          <div className="popupNoBg">
            {/* <BuildingFloorUnitForm name="unitData" isEnabled={true} /> */}
            <ScatteredUnitFormWithDefaultValue name="unitData" syncWithDux={syncWithDux} isEnabled={true} />
          </div>
        </SaveHookFormDialog>
      )}
    </>
  );
};
